var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_8009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75623 17L14.2377 17C16.3514 17 17.6905 14.7241 16.6277 12.8806L9.54182 0.600496C9.07944 -0.204167 7.92049 -0.204167 7.4581 0.600495L0.366263 12.8806C-0.696613 14.7181 0.64249 17 2.75623 17ZM9.54783 4.28153L11.0911 7.26598L14.8142 13.9315C15.0604 14.3578 14.7541 14.9043 14.2437 14.9043L9.54783 14.9043L9.54783 4.28153ZM2.18576 13.9315L5.90883 7.26598L7.4521 4.28153L7.4521 14.9043L2.75623 14.9043C2.23981 14.9043 1.93956 14.3578 2.18576 13.9315Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_8009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(17 17) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTon);
export default __webpack_public_path__ + "static/media/icon-ton.33bbc53d7c97a5720cfceafa10b1fff1.svg";
export { ForwardRef as ReactComponent };